<div class="form-container">
<form #readByPaymentIdForm="ngForm"  (ngSubmit)="onSubmit()" [class.processing]="processing()">

    <server-select></server-select>

    <mat-form-field>
        <mat-label>{{'crete_single.payment_id_label' | translate}}</mat-label>

        <input name="payment-id" matInput [(ngModel)]="paymentId" #payment_id="ngModel" required>

        @if (paymentId().length > 0) {
        <button type="button" matSuffix mat-icon-button aria-label="Clear" (click)="paymentId.set('')">
            <mat-icon>close</mat-icon>
        </button>
        }

        @if((payment_id.dirty || payment_id.touched) &&
        (payment_id.invalid && payment_id.errors?.['required'])
        ) {
        <mat-error>{{'crete_single.payment_id_required' | translate}}</mat-error>
        }

    </mat-form-field>    

    <button type="submit" mat-raised-button class="find-button" [disabled]="!readByPaymentIdForm.form.valid || processing()">
        <mat-icon>search</mat-icon>
        {{'button.find' | translate}}
    </button>    
</form>

@if(processing()) {
    <mat-spinner class="form-spinner" diameter="80"></mat-spinner>
}
</div>